import React from 'react';
import { StyledCookieMessage } from './CookieMessage.styles';
import svtlibCookie from '@svt/cookie';

class CookieMessage extends React.Component {
    componentDidMount() {
        svtlibCookie('PlayCookieInformationRoot');
    }

    render() {
        return <StyledCookieMessage id="PlayCookieInformationRoot" />;
    }
}

export default CookieMessage;
